import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrabankHookCtlService } from '../api/services';
import { PaymentResponseDto } from '../api';

@Component({
    selector: 'app-orabank',
    imports: [],
    templateUrl: './orabank.component.html',
    styleUrl: './orabank.component.css'
})
export class OrabankComponent implements OnInit {

  referenceOrab?:string;
  referenceVersus?:string;

  constructor(private activeRoute:ActivatedRoute,
              private router:Router,
              private orabService:OrabankHookCtlService
  ){

  }
  ngOnInit(): void {
    this.activeRoute.params.subscribe(p =>{
      this.referenceVersus =p['reference'];
      }); 
      this.activeRoute.queryParams.subscribe(par=>{
        this.referenceOrab = par['ref'];
      });
   this.finalizePayment();
  }
  finalizePayment(){
    console.log(this.referenceOrab);
    console.log(this.referenceVersus);
    this.orabService.getStatus(
     this.referenceVersus!!,
     this.referenceOrab!!
    ).subscribe({
      next:(resp:PaymentResponseDto)=>{
        if(resp.status =='PENDING'){
          setTimeout(()=>
            {
              this.finalizePayment();
            },
            60000);
        
      }else {
        let finalStatus='FAILED';
    if(resp.status?.toLowerCase()=='success'||resp.status?.toLowerCase()=='paid'||resp.status?.toLowerCase()=='validated'){
      finalStatus ='PAID';
    }
        this.router.navigateByUrl('receipt/'+this.referenceVersus+'/'+finalStatus);
      }
    },
      error:()=>{
        this.router.navigateByUrl('receipt/'+this.referenceVersus);
      }
    })
    

  }
}
